import { useState } from 'react'
import { Card, Col, Input, Radio, Row, Title } from 'components/common'

export const DiscountMinimumRequirements = () => {
  const [value, setValue] = useState(1)

  const onChange = (e) => {
    console.log('radio checked', e.target.value)
    setValue(e.target.value)
  }

  return (
    <>
      <Card>
        <Row>
          <Col span={12}>
            <Title level={5}>最小要件</Title>
          </Col>
        </Row>
        <Radio.Group onChange={onChange} value={value}>
          <Row style={{ marginBottom: 8 }}>
            <Col span={12}>
              <Radio value={1}>最低予約額（￥）</Radio>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <Input prefix="￥" placeholder="0" />
            </Col>
          </Row>
          <Row>
            <Col span={16}>選択したコレクションにのみ適用されます。</Col>
          </Row>
          <Row style={{ marginTop: 8 }}>
            <Col span={12}>
              <Radio value={2}>最低予約件数（￥)</Radio>
            </Col>
          </Row>
        </Radio.Group>
      </Card>
    </>
  )
}
